import React from 'react';
import { API } from '@gin-betting/core';

import OrganizationList from '../OrganizationList/OrganizationList';
import TournamentsByOrganization from '../TournamentsByOrganization';
import useOrganizationContainer from './useOrganizationContainer';

interface Props {
    sportItem: API.CategorizerItem;
}

const OrganizationContainer: React.FC<Props> = ({ sportItem }) => {
    const {
        categorizerItemsByOrganizations,
        selectedOrganization,
        selectOrganization,
    } = useOrganizationContainer({ sportItem });

    if (selectedOrganization) {
        return (
            <TournamentsByOrganization
                selectedOrganization={selectedOrganization}
                onBackClick={selectOrganization}
            />
        );
    }

    return (
        <OrganizationList
            categorizerItemsByOrganizations={categorizerItemsByOrganizations}
            sportItemCount={sportItem.count}
            selectOrganization={selectOrganization}
        />
    );
};

export default React.memo(OrganizationContainer);
